import { action, computed, observable } from 'mobx';

import { ITranslationsCollection } from '@estee/elc-service';

import { OrderInfo } from '../domain/entities/OrderInfo';
import { OrderRepository } from '../repositories/OrderRepository';
import { OrderTrackingSubmittedUseCase } from '../use-cases/OrderTrackingSubmittedUseCase';

interface IOrderStatusInfo {
    status: string;
    explanation: string;
    description: string;
    subDescription: string;
    deliveryMethod?: string;
    shippedDate?: string;
    trackingUrl?: string;
    statusClassName: string;
    statusHeader?: string;
}

export class OrderStatusViewController {
    private orderRepository: OrderRepository;
    @observable private orderInfo: OrderInfo;

    constructor(orderRepository: OrderRepository) {
        this.orderRepository = orderRepository;
    }

    @action
    public loaded = (translations: ITranslationsCollection) => {
        this.orderRepository.loadTranslations(translations);
    };

    @computed
    public get data() {
        return {
            orderInfo: this.orderInfo,
            isLoading: this.orderRepository.orderTracking.isLoading
        };
    }

    @computed
    public get orderStatusInfo() {
        const { orderStatus, deliveryMethodName, shippingInfo } = this.orderInfo;
        const { trackingUrl, shippedDateFormattedString } = shippingInfo ?? {};

        return orderStatus?.getOrderStatusInfo({
            deliveryMethodName,
            trackingUrl,
            shippedDateFormattedString
        }) as IOrderStatusInfo;
    }

    @action
    public onQueryOrder = async (orderId: string) => {
        this.orderRepository.orderTracking.setQueryOrderNumber(orderId);
        const submitUseCase = new OrderTrackingSubmittedUseCase();
        const orderInfo = await submitUseCase.execute();

        this.orderInfo = orderInfo;
    };
}
